import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import { useRillContext } from "../../../rill/RillReact/share/base";

const {
  PERIOD_FORMATS,
  PRIMARIES,
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../constants");

function View(props) {
  const { t } = useTranslation("dashboard");
  const { locals } = useRillContext();

  _.defaults(locals.query, {
    type: "total",
    units: "metric",
  });

  const { snapshot, query, momentTZ } = locals;
  const { units } = query;
  let exercisesRecordsLoad = _.get(snapshot, "data.exercisesRecordsLoad", {});
  exercisesRecordsLoad =
    query.type === "total"
      ? exercisesRecordsLoad
      : _.pick(exercisesRecordsLoad, [query.type]);

  return (
    <div className="body metrics">
      <h1 className="alt">{t("recordTable.title")}</h1>
      <p>
        {t("recordTable.description")}
      </p>

      <div className="Table-Head">
        <div className="right-side">
          <div className="group">
            <ToggleLinksInput
              name="units"
              options={[
                { text: t("recordTable.kg"), value: "metric" },
                { text: t("recordTable.lbs"), value: "imperial" },
              ]}
            />
          </div>
        </div>

        <div className="left-side">
          <div className="group">
            <ToggleLinksInput
              className="tabs"
              name="type"
              options={[
                { text: t("recordTable.total"), value: "total" },
                { text: t("recordTable.squat"), value: "squat" },
                { text: t("recordTable.bench"), value: "bench" },
                { text: t("recordTable.deadlift"), value: "deadlift" },
              ]}
            />
          </div>
        </div>
      </div>

      <div className="Table-Wrapper">
        <table className="Table">
          <thead>
            <tr>
              <th>
                <span className="left">{t("recordTable.exercise")}</span>
                <span className="right">{t("recordTable.reps")}</span>
              </th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
              <th>11</th>
              <th>12</th>
            </tr>
          </thead>
          <tbody>
            {_.flatMap(PRIMARIES, (primary) => {
              const secondaries = exercisesRecordsLoad[primary];
              return _(secondaries)
                .map((reps, secondary) => {
                  return { reps, secondary };
                })
                .sortBy("secondary")
                .map(({ reps, secondary }) => {
                  const secondaryLabel = secondary ? `(${secondary})` : "";
                  return (
                    <tr key={primary + secondary}>
                      <td>
                        {_.capitalize(primary)} {secondaryLabel}
                      </td>
                      {_.map(_.range(1, 13), (i) => {
                        const load = _.get(reps[i], "load");
                        const date = momentTZ(_.get(reps[i], "date"));
                        if (!load) return <td key={i} />;
                        return (
                          <td key={i}>
                            <a
                              href={`/dashboard/program-builder/?day=${date.format(
                                DATE_DAY_FORMAT
                              )}`}
                            >
                              {locals.fromMetric(load, units)}
                            </a>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
                .value();
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default View;
